"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { channels as data } from "@/lib/data/contact";

const accent = "var(--color-cyan)";

export function Channels() {
  return (
    <Section id="channels" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-cyan)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Primary Channels</span>
              <div className="mt-4 space-y-3">
                {data.primary.map((p, i) => (
                  <div key={i} className="text-sm">
                    <div className="font-semibold" style={{ color: accent }}>{p.label}</div>
                    <div className="text-[rgb(var(--fg-muted))] mt-0.5 leading-relaxed">{p.body}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Digital Channels</span>
              <ul className="mt-4 space-y-2">
                {data.digital.map((d, i) => (
                  <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{d}</li>
                ))}
              </ul>
              <div className="mt-5">
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Event Channels</span>
                <ul className="mt-3 space-y-2">
                  {data.events.map((e, i) => (
                    <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{e}</li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={300}>
          <div className="mt-8 glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
            <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Channel Selection Guidance</span>
            <div className="mt-4 grid sm:grid-cols-2 gap-3">
              {data.guidance.map((g, i) => (
                <div key={i} className="flex items-baseline gap-2 text-sm">
                  <span className="font-semibold" style={{ color: accent }}>{g.label}</span>
                  <span className="text-[rgb(var(--fg-muted))]">— {g.channel}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
